export class CcdStringUtils {

    static stringToNumber(val : string) {
        let res : number = null;
        if (val) {
          res = +val;
        }
        return res;
    }
    
    static numberToString(num : number) {
        let res : string = null;
        if (num) {
          res = num.toString();
        }
        return res;
    }

    /**
     * Conversion string --> boolean
     * @param stringVal 
     */
    static stringToBoolean(stringVal: string) {
      let result: boolean;
      if (stringVal == "true" || stringVal == "false") {
          result = (stringVal == "true");
      }
      return result;
  }

  /**
   * Indique si une string peut être interprétée en boolean
   * @param stringVal 
   */
  static isStringBoolean(stringVal : string) : boolean {
      return (stringVal == "true" || stringVal == "false");
  }

  static formatDateToString(date: Date): string {
    if (typeof date === 'string') {
      date = new Date(date); // Convertit la chaîne en Date
    }
 
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return '';
    }
 
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Mois de 0 à 11, donc +1
    const day = String(date.getDate()).padStart(2, '0');
 
    return `${day}/${month}/${year}`;
 
  }

  static parseDateFromString(dateStr: any): Date | null {
    if (dateStr instanceof Date) {
      return dateStr; // Déjà une date valide, on la retourne
    }
 
    if (typeof dateStr !== 'string') {
      return null;
    }
 
    const parts = dateStr.split('/');
    if (parts.length !== 3) return null;
 
    const [day, month, year] = parts.map(Number);
 
    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
 
    return new Date(year, month - 1, day,0,0,0,0);
  }
}